export class RestoreGcpCloudSqlRequest {
    'restoreAccountId';
    'destination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "GcpCloudSqlRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGcpCloudSqlRequest.attributeTypeMap;
    }
    constructor() {
    }
}
